import type { RootStackParamList } from './types';

type WebRoutesName = {
  [RouteName in keyof RootStackParamList]: string;
};

export const RouteScreens: WebRoutesName = {
  MarisaServicos_Home: '/',
  MarisaServicos_Iframe: '/iframe',
  MarisaServicos_ContractSellerInfo: '/servicos/contrato/vendedor/informacoes',
  MarisaServicos_ContractSellerConfirmation:
    '/servicos/contrato/vendedor/confirmacao',
  MarisaServicos_AboutMarisaCard: '/sobre-cartao-marisa',
  MarisaServicos_Components: 'servicos/components',
  MarisaServicos_MarisaTakesCareDetails: 'servicos/marisa-cuida/detalhes',
  MarisaServicos_MarisaTakesCareInsurance: 'servicos/marisa-cuida/seguro',
  MarisaServicos_MarisaTakesCareContract: 'servicos/marisa-cuida/contrato',
  MarisaServicos_BagProtectionDetails: 'servicos/bolsa-protecao',
  MarisaServicos_BagProtectionContract: 'servicos/bolsa-protecao/contrato',
  MarisaServicos_IncomeProtectionDetails: 'servicos/protecao-renda',
  MarisaServicos_IncomeProtectionContract: 'servicos/protecao-renda/contrato',
  MarisaServicos_Checkout: 'servicos/checkout',
  MarisaServicos_CheckoutSuccess: 'servicos/checkout/sucesso',
  MarisaServicos_MarisaAutoContract: 'servicos/marisa-seguro-auto/contrato',
  MarisaServicos_SignIn: 'servicos/entrar',
  MarisaServicos_CreateAccount: 'servicos/cadastro',
  MarisaServicos_ForgotPassword: 'servicos/esqueci-a-senha',
  MarisaServicos_NoAuthContractPage: 'servicos/cpf-segurado',
  MarisaServicos_TermsAndConditions: 'servicos/cadastro/termos-e-condicoes',
  MarisaServicos_CheckoutError: 'servicos/checkout/error',
  MarisaServicos_HiredInsuranceDetailsTakesCare: 'meus-servicos/marisa-cuida',
  MarisaServicos_HiredInsuranceCallCenterTakesCare:
    'meus-servicos/marisa-cuida/central-atendimento',
  MarisaServicos_HiredInsuranceCancelTakesCare:
    'meus-servicos/marisa-cuida/cancelamento',
  MarisaServicos_HiredInsuranceCancelSuccessTakesCare:
    'meus-servicos/marisa-cuida/cancelamento/sucesso',
  MarisaServicos_HiredInsuranceCancelFailTakesCare:
    'meus-servicos/marisa-cuida/cancelamento/erro',
  MarisaServicos_HiredInsuranceCoverageTakesCare:
    'meus-servicos/marisa-cuida/cobertura',
  MarisaServicos_HiredInsuranceDetailsAuto:
    'meus-servicos/seguro-auto/detalhes',
  MarisaServicos_HiredInsuranceCancelAuto:
    'meus-servicos/seguro-auto/cancelamento',
  MarisaServicos_HiredInsuranceCoverageAuto:
    'meus-servicos/seguro-auto/cobertura',
  MarisaServicos_HiredInsuranceSinisterAuto:
    'meus-servicos/seguro-auto/sinistro',
  MarisaServicos_HiredInsuranceDetailsBagProtection:
    'meus-servicos/bolsa-protecao/detalhes',
  MarisaServicos_HiredInsuranceCoverageBagProtection:
    'meus-servicos/bolsa-protecao/cobertura',
  MarisaServicos_HiredInsuranceCallCenterBagProtection:
    'meus-servicos/bolsa-protecao/central-atendimento',
  MarisaServicos_HiredInsuranceCancelBagProtection:
    'meus-servicos/bolsa-protecao/cancelamento',
  MarisaServicos_HiredInsuranceCancelSuccessBagProtection:
    'meus-servicos/bolsa-protecao/cancelamento/sucesso',
  MarisaServicos_HiredInsuranceCancelFailBagProtection:
    'meus-servicos/bolsa-protecao/cancelamento/erro',
  MarisaServicos_HiredInsuranceDetailsIncomeProtection:
    'meus-servicos/protecao-renda/detalhes',
  MarisaServicos_HiredInsuranceCoverageIncomeProtection:
    'meus-servicos/protecao-renda/cobertura',
  MarisaServicos_HiredInsuranceCallCenterIncomeProtection:
    'meus-servicos/protecao-renda/central-atendimento',
  MarisaServicos_HiredInsuranceCancelIncomeProtection:
    'meus-servicos/protecao-renda/cancelamento',
  MarisaServicos_HiredInsuranceCancelSuccessIncomeProtection:
    'meus-servicos/protecao-renda/cancelamento/sucesso',
  MarisaServicos_HiredInsuranceCancelFailIncomeProtection:
    'meus-servicos/protecao-renda/cancelamento/erro',
  MarisaServicos_UnemploymentAssistanceDetails:
    'servicos/assistencia-desemprego',
  MarisaServicos_OdontoProtectionDetails: 'servicos/protecao-odonto',
  MarisaServicos_MarisaAutoDetails: 'servicos/marisa-auto',

  //CREDSYSTEM
  Credsystem_SignIn: 'credsystem/entrar',
  Credsystem_OTPValidation: 'credsystem/validar-codigo',
  Credsystem_Dashboard: 'credsystem/dashboard',
  Credsystem_SAC: 'credsystem/sac',
  Credsystem_About: 'credsystem/sobre',
  Credsystem_Settings: 'credsystem/configuracoes',
  Credsystem_Invoices: 'credsystem/faturas',
};
